export const heroStats = [
  { value: "13", label: "Régions couvertes", icon: "ri-map-2-line" },
  { value: "45", label: "Provinces préparées", icon: "ri-community-line" },
  { value: "100%", label: "Montants en FCFA", icon: "ri-money-dollar-circle-line" },
  { value: "24/7", label: "Accès à vos données", icon: "ri-cloud-line" },
];

export const problems = [
  {
    icon: "ri-book-2-line",
    title: "Cahiers et notes dispersés",
    description: "Les loyers, les reçus et les contrats sont notés dans plusieurs cahiers difficiles à retrouver.",
  },
  {
    icon: "ri-file-excel-2-line",
    title: "Fichiers Excel fragiles",
    description: "Un tableur partagé se perd, se duplique ou contient des erreurs de saisie impossibles à tracer.",
  },
  {
    icon: "ri-calendar-close-line",
    title: "Suivi des loyers incertain",
    description: "Impossible de savoir en un coup d'œil qui a payé, qui doit payer et depuis quand.",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "Impayés oubliés",
    description: "Les retards s'accumulent sans liste claire, ce qui complique les relances et les décisions.",
  },
  {
    icon: "ri-file-warning-line",
    title: "Contrats non centralisés",
    description: "Les échéances, cautions et avances ne sont pas toujours vérifiables rapidement.",
  },
  {
    icon: "ri-building-2-line",
    title: "Plusieurs immeubles à gérer",
    description: "Chaque immeuble fonctionne différemment et la vue d'ensemble manque toujours.",
  },
  {
    icon: "ri-group-line",
    title: "Plusieurs propriétaires",
    description: "Pour une agence, séparer les revenus et les biens de chaque propriétaire devient un casse-tête.",
  },
  {
    icon: "ri-folder-warning-line",
    title: "Suivi administratif lourd",
    description: "Documents, reçus et justificatifs sont éparpillés et difficiles à présenter.",
  },
];

export const features = [
  { icon: "ri-building-2-line", title: "Gestion des immeubles", description: "Créez et organisez vos immeubles par région, province, commune et secteur." },
  { icon: "ri-home-4-line", title: "Gestion des biens", description: "Appartements, studios, chambres, boutiques et bureaux avec statut et loyer." },
  { icon: "ri-user-3-line", title: "Gestion des locataires", description: "Fiches complètes : coordonnées, profession, pièce d'identité, contact d'urgence." },
  { icon: "ri-file-text-line", title: "Gestion des contrats", description: "Dates, loyer, caution, avance, échéance et statut du contrat." },
  { icon: "ri-wallet-3-line", title: "Gestion des loyers", description: "Suivi par période, montant, échéance et statut de chaque loyer." },
  { icon: "ri-hand-coin-line", title: "Paiements", description: "Enregistrez les paiements et générez des reçus pour chaque locataire." },
  { icon: "ri-alert-line", title: "Impayés", description: "Visualisez les retards, la durée et les montants dus par locataire." },
  { icon: "ri-tools-line", title: "Entretien", description: "Suivez les demandes, priorités, prestataires et coûts de maintenance." },
  { icon: "ri-money-cny-circle-line", title: "Dépenses", description: "Réparation, électricité, plomberie, nettoyage, sécurité et autres charges." },
  { icon: "ri-folder-line", title: "Documents", description: "Contrats, pièces d'identité, reçus, factures et documents immobiliers." },
  { icon: "ri-bar-chart-box-line", title: "Statistiques", description: "Revenus, taux d'occupation, biens disponibles et évolution des revenus." },
  { icon: "ri-notification-3-line", title: "Notifications", description: "Alertes sur loyers, paiements, impayés, contrats et abonnements." },
  { icon: "ri-team-line", title: "Employés", description: "Ajoutez des employés et attribuez des autorisations précises." },
  { icon: "ri-vip-diamond-line", title: "Abonnement", description: "Gérez votre formule, vos limites et l'utilisation de votre espace." },
];

export const ownerBenefits = [
  "Suivre tous vos immeubles depuis un seul tableau de bord",
  "Savoir à tout moment quels biens sont occupés ou disponibles",
  "Garder une fiche complète pour chaque locataire",
  "Centraliser les contrats et leurs échéances",
  "Suivre les loyers, paiements et impayés en FCFA",
  "Enregistrer les dépenses et les demandes d'entretien",
  "Conserver tous vos documents au même endroit",
  "Visualiser la rentabilité avec des statistiques claires",
];

export const agencyBenefits = [
  "Gérer plusieurs propriétaires dans un espace unique",
  "Relier chaque immeuble à son propriétaire",
  "Suivre les biens, locataires, contrats et loyers par propriétaire",
  "Ajouter des employés avec des autorisations adaptées",
  "Suivi multi-propriétaires et rapports de signalement",
  "Comparer les performances entre immeubles",
];

export const agencyChain = [
  { label: "Agence", icon: "ri-building-4-line" },
  { label: "Propriétaires", icon: "ri-user-star-line" },
  { label: "Immeubles", icon: "ri-building-2-line" },
  { label: "Biens", icon: "ri-home-4-line" },
  { label: "Locataires", icon: "ri-user-3-line" },
  { label: "Contrats", icon: "ri-file-text-line" },
  { label: "Loyers", icon: "ri-wallet-3-line" },
  { label: "Paiements", icon: "ri-hand-coin-line" },
];

export const homeSteps = [
  { title: "Créer son compte", description: "Choisissez Propriétaire ou Agence et créez votre espace en quelques minutes.", icon: "ri-user-add-line" },
  { title: "Ajouter ses immeubles", description: "Renseignez la localisation : région, province, commune et secteur.", icon: "ri-building-2-line" },
  { title: "Ajouter biens et locataires", description: "Enregistrez vos biens, attribuez-les aux locataires et suivez les statuts.", icon: "ri-home-4-line" },
  { title: "Gérer contrats et loyers", description: "Créez les contrats, suivez les loyers, les paiements et les impayés.", icon: "ri-wallet-3-line" },
];

export const howItWorksSteps = [
  { step: "01", title: "Choisir Propriétaire ou Agence", description: "Sélectionnez le type de compte adapté à votre activité lors de l'inscription.", icon: "ri-user-settings-line" },
  { step: "02", title: "Créer un compte", description: "Renseignez vos informations et choisissez votre formule d'abonnement.", icon: "ri-user-add-line" },
  { step: "03", title: "Configurer son espace", description: "Personnalisez votre profil, vos préférences et votre organisation.", icon: "ri-settings-3-line" },
  { step: "04", title: "Ajouter les immeubles", description: "Enregistrez vos immeubles avec leur localisation complète.", icon: "ri-building-2-line" },
  { step: "05", title: "Ajouter les biens", description: "Créez les appartements, studios, boutiques et bureaux de chaque immeuble.", icon: "ri-home-4-line" },
  { step: "06", title: "Ajouter les locataires", description: "Constituez des fiches locataires complètes et fiables.", icon: "ri-user-3-line" },
  { step: "07", title: "Créer les contrats", description: "Définissez loyer, caution, avance, échéance et conditions.", icon: "ri-file-text-line" },
  { step: "08", title: "Suivre les loyers", description: "Consultez les loyers par période et identifiez ceux à encaisser.", icon: "ri-wallet-3-line" },
  { step: "09", title: "Enregistrer les paiements", description: "Enregistrez chaque encaissement et générez un reçu.", icon: "ri-hand-coin-line" },
  { step: "10", title: "Suivre impayés, dépenses et entretiens", description: "Gardez le contrôle sur les retards, les charges et la maintenance.", icon: "ri-tools-line" },
  { step: "11", title: "Consulter les statistiques", description: "Analysez la rentabilité et le taux d'occupation de votre patrimoine.", icon: "ri-bar-chart-box-line" },
];


export const faqs = [
  { question: "Qui peut utiliser la plateforme ?", answer: "La plateforme s'adresse aux propriétaires d'immeubles, aux agences immobilières et à leurs employés. Chaque profil dispose d'un espace adapté à ses besoins." },
  { question: "Est-elle adaptée aux propriétaires ?", answer: "Oui. Un propriétaire peut gérer ses immeubles, ses biens, ses locataires, ses contrats, ses loyers, ses paiements, ses impayés, ses dépenses et ses documents depuis un tableau de bord unique." },
  { question: "Est-elle adaptée aux agences ?", answer: "Oui. Une agence gère plusieurs propriétaires, leurs immeubles et leurs biens, avec la possibilité d'ajouter des employés et de définir des autorisations." },
  { question: "Peut-on gérer plusieurs immeubles ?", answer: "Oui, le nombre d'immeubles dépend de votre formule. La formule Agence permet un nombre illimité d'immeubles." },
  { question: "Peut-on gérer plusieurs propriétaires ?", answer: "Oui, la gestion multi-propriétaires est incluse dans la formule Agence, avec un suivi séparé des revenus de chaque propriétaire." },
  { question: "Peut-on avoir plusieurs employés ?", answer: "Oui. Les formules Professionnel et Agence permettent d'ajouter plusieurs utilisateurs, avec des autorisations précises pour chaque employé." },
  { question: "Quels moyens de paiement sont prévus ?", answer: "L'abonnement IMMO BF se règle par Orange Money (64 59 17 18), Moov Money (72 62 19 01) ou en espèces. Pour Orange Money et Moov Money, une preuve de paiement est requise et l'abonnement est activé après vérification. Pour les loyers, vous pouvez enregistrer les encaissements reçus (espèces, Orange Money, Moov Money, virement, chèque)." },
  { question: "Peut-on commencer gratuitement ?", answer: "Oui, la formule Gratuite permet de découvrir la plateforme avec 1 immeuble, 5 biens, 5 locataires et 5 contrats." },
  { question: "Peut-on changer de formule ?", answer: "Oui, vous pouvez changer de formule à tout moment depuis votre espace Abonnement. Les limites sont mises à jour immédiatement." },
  { question: "Quelle est la différence entre mensuelle et annuelle ?", answer: "La facturation annuelle offre une économie de 10 % par rapport au paiement mensuel, pour la même formule." },
  { question: "Peut-on utiliser la plateforme sur téléphone ?", answer: "Oui, l'interface est entièrement responsive et fonctionne sur smartphone, tablette et ordinateur." },
];

export const homeFaqPreview = faqs.slice(0, 5);

export const testimonials = [
  {
    quote:
      "Avant, je suivais mes loyers dans un cahier. Aujourd'hui je vois en un instant qui a payé et qui doit encore régler son loyer.",
    name: "Abdoulaye Sawadogo",
    role: "Propriétaire, Ouagadougou",
    initials: "AS",
  },
  {
    quote:
      "Nous gérons les immeubles de plusieurs propriétaires. Le suivi par propriétaire nous a fait gagner un temps précieux.",
    name: "Aïcha Ouédraogo",
    role: "Directrice d'agence, Bobo-Dioulasso",
    initials: "AO",
  },
  {
    quote:
      "Les impayés sont enfin visibles et les relances sont plus simples. Nos propriétaires reçoivent des rapports clairs.",
    name: "Issouf Kaboré",
    role: "Gestionnaire, Koudougou",
    initials: "IK",
  },
];

export const aboutValues = [
  { icon: "ri-shield-check-line", title: "Fiabilité", description: "Des données centralisées et cohérentes pour piloter votre patrimoine sereinement." },
  { icon: "ri-map-pin-2-line", title: "Ancrage local", description: "Une plateforme pensée pour le Burkina Faso : territoire, FCFA et usages locaux." },
  { icon: "ri-lightbulb-line", title: "Simplicité", description: "Une interface claire, utilisable sans formation technique préalable." },
  { icon: "ri-line-chart-line", title: "Transparence", description: "Des rapports lisibles sur les revenus, les charges et l'occupation des biens." },
];

export const aboutMilestones = [
  { year: "2023", title: "Naissance du projet", description: "Constat de la difficulté de gestion locative dans les grandes villes du Burkina Faso." },
  { year: "2024", title: "Premiers tests terrain", description: "Conception des premiers modules avec des propriétaires et des agences partenaires." },
  { year: "2025", title: "Plateforme structurée", description: "Mise en place des espaces Propriétaire et Agence et du suivi territorial complet." },
  { year: "2026", title: "Ouverture", description: "Lancement de la plateforme et accompagnement des premiers utilisateurs." },
];

export const subjectOptions = [
  { value: "commercial", label: "Demande commerciale" },
  { value: "support", label: "Assistance technique" },
  { value: "partenariat", label: "Partenariat" },
  { value: "formation", label: "Formation / Accompagnement" },
  { value: "autre", label: "Autre" },
];

export const solutionTabs = [
  { id: "proprietaires", label: "Propriétaires", icon: "ri-user-star-line" },
  { id: "agences", label: "Agences immobilières", icon: "ri-building-4-line" },
];